import App from "@/App";
import { CartExample } from "@/components/cartExample/CartExample";
import {
  AuthOptions,
  Categories,
  Brands,
  Products,
  ProductDetails,
  CategoryProducts,
  BrandProducts,
  EmailVerification,
  Cart,
  Checkout,
  QuickReorder,
  AddProduct,
  SellerDashboard,
  ManageInventory,
  Home,
  AddCategory,
  AddBrand,
  EditCategory,
  EditBrand,
  EditProduct,
  SalesAnalytics,
  Payouts,
  SellerProfile,
  OrderHistory,
  UserAccount,
  SellerRegistration,
  ThankYou,
  UpdateBuyerProductStock,
  StylistRegistration,
  Login,
  DistributorRegistration,
  ResetPasswordWizard,
} from "@/screens";
  import { ManageUsers, SuperAdminDashboard } from "@/screens/superAdmin"; 

export const RoutingList = [
  {
    route: "/",
    element: <App />,
    is_protected: false,
    children: [
      {
        route: "",
        element: <Home />,
        is_protected: false,
      },

      {
        route: "auth",
        element: <AuthOptions />,
        is_protected: false,
      },
      {
        route: "categories",
        element: <Categories />,
        is_protected: false,
      },
      {
        route: "brands",
        element: <Brands />,
        is_protected: false,
      },
      {
        route: "products",
        element: <Products />,
        is_protected: false,
      },
      {
        route: "product/:id",
        element: <ProductDetails />,
        is_protected: false,
      },
      {
        route: "category/:id",
        element: <CategoryProducts />,
        is_protected: false,
      },
      {
        route: "brand/:id",
        element: <BrandProducts />,
        is_protected: false,
      },
      {
        route: "email-verification",
        element: <EmailVerification />,
        is_protected: false,
      },
      {
        route: "cart",
        element: <Cart />,
        is_protected: false,
      },
      {
        route: "checkout",
        element: <Checkout />,
        is_protected: true,
        allowedRoles: ["buyer", "seller"],
      },
      {
        route: "quick-reorder",
        element: <QuickReorder />,
        is_protected: false,
      },
      {
        route: "order-history",
        element: <OrderHistory />,
        is_protected: true,
        allowedRoles: ["buyer", "seller"],
      },
      {
        route: "account",
        element: <UserAccount />,
        is_protected: true,
        allowedRoles: ["buyer"],
      },
      {
        route: "distributor-signup",
        element: <DistributorRegistration />,
        is_protected: false,
        allowedRoles: ["buyer"],
      },
      {
        route: "thank-you",
        element: <ThankYou />,
        is_protected: true,
        allowedRoles: ["buyer", "seller"],
      },
      {
        route: "update-product-stock/:id",
        element: <UpdateBuyerProductStock />,
        is_protected: false,
      },
      {
        route: "stylist-signup",
        element: <StylistRegistration />,
        is_protected: false,
      },

      {
        route: "login",
        element: <Login />,
        is_protected: false,
      },
      {
        route: "forgot-password",
        element: <ResetPasswordWizard />,
        is_protected: false,
      },
      {
        route: "distributor-registration",
        element: <SellerRegistration />,
        is_protected: false,
      },
      {
        route: "cart-example",
        element: <CartExample />,
        is_protected: false,
      },
      {
        route: "*",
        element: (
          <div className="h-screen flex items-center justify-center">
            <span>Page not found</span>
          </div>
        ),
        is_protected: false,
      },
    ],
  },
  {
    route: "/seller",
    element: <SellerDashboard />,
    is_protected: true,
    allowedRoles: ["seller"],
    children: [
      {
        route: "",
        element: <ManageInventory />,
        is_protected: true,
        allowedRoles: ["seller"],
      },
      {
        route: "manage-inventory/add-product",
        element: <AddProduct />,
        is_protected: true,
        allowedRoles: ["seller"],
      },
      {
        route: "manage-inventory/add-category",
        element: <AddCategory />,
        is_protected: true,
        allowedRoles: ["seller"],
      },
      {
        route: "manage-inventory/add-brand",
        element: <AddBrand />,
        is_protected: true,
        allowedRoles: ["seller"],
      },
      {
        route: "manage-inventory/edit-product/:id",
        element: <EditProduct />,
        is_protected: true,
        allowedRoles: ["seller"],
      },
      {
        route: "manage-inventory/edit-category/:id",
        element: <EditCategory />,
        is_protected: true,
        allowedRoles: ["seller"],
      },
      {
        route: "manage-inventory/edit-brand/:id",
        element: <EditBrand />,
        is_protected: true,
        allowedRoles: ["seller"],
      },

      {
        route: "sales",
        element: <SalesAnalytics />,
        is_protected: true,
        allowedRoles: ["seller"],
      },
      {
        route: "payouts",
        element: <Payouts />,
        is_protected: true,
        allowedRoles: ["seller"],
      },
      {
        route: "profile",
        element: <SellerProfile />,
        is_protected: true,
        allowedRoles: ["seller"],
      },
    ],
  },
  {
    route: "/super-admin",
    element: <SuperAdminDashboard />,
    is_protected: true,
    allowedRoles: ["super-admin"],
    children: [
      {
        route: "",
        element: <ManageUsers />,
        is_protected: true,
        allowedRoles: ["super-admin"],
      },
    ],

  }
];
